import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import LeadServicePanel from "../../components/leadservice-panel/leadservice-panel";
import Leadservice from "../../components/leadservice-panel/leadService";
import LeadAppointments from "../../components/leadservice-panel/leadAppointment";

const LeadServicePanelPage = () => {
  return (
    <>
      <Routes>
        <Route element={<LeadServicePanel />}>
          <Route index path="leadservice" element={<Leadservice />} />
          <Route path="lead-appointments" element={<LeadAppointments />} />
          <Route path="*" element={<Navigate to="leadservice" />} />
        </Route>
      </Routes>
      <Outlet />
    </>
  );
};
export default LeadServicePanelPage;
